import { RJSFSchema } from '@rjsf/utils';

export const StripeConfigSchema: RJSFSchema = {
    type: "object",
    properties: {
        sk_key: { type: 'string' },
        pk_key: {type: 'string'},
    }
  }